<template>
  <div>
    <Detail
      :detailQuery="detailQuery"
      :title="title"
      :nodes="nodes"
      :user="user"
      :audits="audits"
      :auditHistory="auditHistory"
      @complete="getObject"
    >
    <template>
      <el-divider content-position="left">发票信息</el-divider>
      <el-form-item label="所属项目">
        <el-input v-model="detail.projectName" readonly></el-input>
      </el-form-item>
      <el-form-item
        v-if="detail.contractName"
        label="项目合同"
        prop="contractName"
      >
        <el-input v-model="detail.contractName" readonly></el-input>
      </el-form-item>
      <el-form-item label="开票时间">
        <el-date-picker
            readonly
            v-model="detail.invoiceTime"
            type="date"
            placeholder="选择开票时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="发票金额">
        <el-input v-model="detail.invoiceAmount" maxlength="12" readonly>
          <template slot="append">{{ getDigitUppercase }}</template>
        </el-input>
      </el-form-item>
      <el-form-item label="发票类型">
        <el-radio-group v-model="detail.invoiceType" disabled>
          <el-radio :label="1">电子普票</el-radio>
          <el-radio :label="2">纸质普票</el-radio>
          <el-radio :label="3">电子专票</el-radio>
          <el-radio :label="4">纸质专票</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="单位名称">
        <el-input v-model="detail.invoiceCompany" readonly></el-input>
      </el-form-item>
      <el-form-item label="纳税人识别号">
        <el-input v-model="detail.taxCode" readonly></el-input>
      </el-form-item>
      <el-form-item label="地址及电话">
        <el-input v-model="detail.contact" readonly></el-input>
      </el-form-item>
      <el-form-item label="开户行及账号">
        <el-input v-model="detail.bankInfo" readonly></el-input>
      </el-form-item>
      <el-form-item label="发票备注">
        <el-input type="textarea" rows=5 maxlength="300" v-model="detail.remarks" readonly></el-input>
      </el-form-item>
    </template>
  </Detail>
  </div>
</template>

<script>
import Detail from "@/components/detail/Detail";
import { digitUppercase } from "@/util";
import { requestApplyDetail } from "@/api";

export default {
  components: { Detail },
  props: {
    // 接收父组件传入的参数
    query: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      user: {
        realName: "",
        deptName: "",
      },
      nodes: [],
      detail: {
        projectName: "",
        contractName: "",
        invoiceTime: "",
        invoiceAmount: "",
        invoiceType: 1,
        invoiceCompany: "",
        taxCode: "",
        contact: "",
        bankInfo: "",
        remarks: "",
      },
      audits: [],
      auditHistory: [],
      detailQuery: {},
      title: { name: '发票开具申请详情', path: '' }
    };
  },
  computed: {
    getDigitUppercase() {
      return digitUppercase(this.detail.invoiceAmount);
    },
  },
  created() {
    this.applyId = this.query.applyId
    this.applyServiceId = this.query.applyServiceId
    this.applyType = this.query.applyType
    this.detailQuery.applyId = this.query.applyId
    this.detailQuery.applyServiceId = this.query.applyServiceId
    this.detailQuery.applyType = this.query.applyType
    this.getObject()
  },
  methods: {
    getObject() {
      requestApplyDetail({
        applyId: this.applyId,
        applyServiceId: this.applyServiceId,
        applyType: this.applyType
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            this.detail = res.object.detail
            this.audits = res.object.audits
            this.auditHistory = res.object.auditHistory
            this.user = res.object.user
            this.nodes = res.object.nodes
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    }
  }
};
</script>
